import styled from "styled-components";
import themes from "@/styles/themes";
import {mdiAlert, mdiClose} from "@mdi/js";
import Icon from "@mdi/react";
import {SET_MODAL} from "@/store/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import Events from "@/utils/Events";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import { useEffect } from "react";

const Block = styled.div`
  background: white;
  padding: 34px 38px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 7px 40px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #d6d6d6;
  position: relative;
`
const ContentArea = styled.div`
  position: relative;
  width: 252px;
`
const IconDiv = styled.div`
  background: ${themes.red};
  color: ${themes.white};
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
`
const CallAction = styled.p`
  color: ${themes.estadao};
  font-weight: 700;
  line-height: 1.2;
`
const Text = styled.p`
  font-size: 12px;
`
const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${themes.grey};
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 12px;

  svg {
    width: 14px;
    height: 14px;
  }
`
export default function ErroProcessamento() {
    const dispatch = useDispatch();
    const offer_type = useSelector(GET_OFFER_TYPE)
    const events = new Events();
  
    useEffect(()=>{
      events.trigger("pagamento_cartao_falha_pagamento", { offer_type })
    });

    return (
        <Block>
            <CloseButton onClick={() => {
                dispatch(SET_MODAL({type: null, show: false})), events.trigger("pagamento_cartao_fechar_falha_pagamento", { offer_type })
            }}><Icon path={mdiClose} size={1}></Icon></CloseButton>

            <ContentArea>
                <IconDiv>
                    <Icon path={mdiAlert} size={1}/>
                </IconDiv>
                <CallAction>
                    Houve um problema <br/>
                    no seu pagamento!
                </CallAction>
                <Text>
                    Ocorreu um erro na transação com este cartão.
                    Verifique os detalhes e tente novamente ou use outra de forma de pagamento.
                </Text>
            </ContentArea>
        </Block>
    )
}